import React, { useEffect, useState } from 'react'
import { Redirect } from 'react-router'

const getEstadoFormatted = (estado) => {
    if(estado === "P"
    || estado === "A"
    || estado === "K"
    || estado === "F") return 'Pago';
    if(estado === "T") return 'Realizado';
    return 'Impago';
}

function Itemturnomin({ datos }) {

    const [redirigir, setRedirigir] = useState("")
    const [existeCobro, setExisteCobro] = useState(false)



    useEffect(() => {



    }, [datos])


    const handleVerTurno = () => {
        setRedirigir("/buscarturno?id_turno=" + datos.id)
    }

    return (
        <>
            <div onClick={handleVerTurno} className="card p-3" style={{ display: "inline-block", width: "100%" }} >
                <div className="row">
                    <div className="col-md"><span style={{ display: "inline-block" }}><b>Dominio:</b>&nbsp;{datos.datos.dominio}&nbsp;&nbsp;</span></div>
                    <div className="col-md"><span style={{ display: "inline-block" }}><b>Nombre:</b>&nbsp;{datos.datos.nombre}&nbsp;&nbsp;</span></div>
                    <div className="col-md"><span style={{ display: "inline-block" }}><b>Estado:</b>&nbsp;
                        {
                            getEstadoFormatted(datos.estado)
                        }
                    &nbsp;&nbsp;</span></div>
                    <div className="col-md"><span style={{ display: "inline-block" }}><b>Hora:</b>&nbsp;{datos.hora}&nbsp;&nbsp;</span></div>
                    <div className="col-md"><span style={{ display: "inline-block" }}><b>Tel:</b>&nbsp;{datos.datos.telefono || ''}&nbsp;&nbsp;</span></div>
                </div>
            </div>
            <br /><br />

            { redirigir && <Redirect to={redirigir} />}

        </>
    )
}

export default Itemturnomin;
